import dayjs from "dayjs";
import i18n from "../../../../i18n/i18n";

type documents = {
  icoName: string;
  title: string;
  subTitle: string;
};

export const transformDataBadge = (cardsAndBadges: TCardsAndBadges[] | []) => {
  return cardsAndBadges.map((cardOrbadge) => {
    return {
      icoName: "certificate",
      title: i18n.t("collaborator.badges", "Badges"),
      subTitle: `${cardOrbadge.fleet_card.fleet_card_type.type} <br/>
                    ${cardOrbadge.fleet_card.fleet_card_type.marque} <br/> 
                    ${
                      cardOrbadge.fleet_card.release_date
                        ? dayjs(cardOrbadge.fleet_card.release_date).format(
                            "DD-MM-YYYY"
                          )
                        : ""
                    }`,
    };
  }) as documents[];
};
